import React__default from 'react';

var FooterUserInfoColumnComponent = function (_a) {
    var children = _a.children, className = _a.className;
    return React__default.createElement("div", { className: "pgc-footer-user-column ".concat(className) }, children);
};
var Span = function (_a) {
    var text = _a.text, isDarkTest = _a.isDarkTest, isMoneyText = _a.isMoneyText;
    return (React__default.createElement("span", { className: "".concat(isDarkTest ? 'pgc-footer-user-dark-text' : isMoneyText ? 'pgc-footer-user-money-text' : '') }, text));
};
var Div = function (_a) {
    var children = _a.children;
    return React__default.createElement("div", { className: 'pgc-footer-user-id hit' }, children); // add/remove classes "double" || "split" || "hit" || "stand" || "surrender" || "bust"
};
var P = function (_a) {
    var children = _a.children;
    return React__default.createElement("p", { className: 'pgc-footer-user-money' }, children);
};
var Icon = function (_a) {
    var _b = _a.iconName, iconName = _b === void 0 ? 'users1' : _b;
    return React__default.createElement("i", { className: "icon-".concat(iconName) });
};
var FooterUserInfoColumn = Object.assign(FooterUserInfoColumnComponent, {
    Span: Span,
    Div: Div,
    P: P,
    Icon: Icon,
});

export { FooterUserInfoColumn };
